export const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
export const FILE_SERVICE_BASE_URL = `${process.env.REACT_APP_FILE_SERVICE_BASE_URL}`

export const APPD_KEY = `${process.env.REACT_APP_APPD_KEY}`;

export const STREAMING_URL = FILE_SERVICE_BASE_URL;